import { render, staticRenderFns } from "./PhoneNumberText.vue?vue&type=template&id=1ad54c24&scoped=true&lang=pug&"
import script from "./PhoneNumberText.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberText.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberText.vue?vue&type=style&index=0&id=1ad54c24&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad54c24",
  null
  
)

export default component.exports